import { AppointmentOrderItem } from '@spike/order-model';
import { FunctionComponent } from 'react';
import MembershipIcon from '../Memberships/MembershipIcon';
import styles from './AppointmentData.module.css';
import PriceItem from './PriceItem';

export interface AppointmentDataProps {
    appointmentItem: AppointmentOrderItem;
    className?: string;
}

export const AppointmentData: FunctionComponent<AppointmentDataProps> = props => {
    const appointment = props.appointmentItem.appointment;
    const orderItem = props.appointmentItem.orderItem;

    const hasMembershipApplied = orderItem.redeem !== undefined;

    const firstLine = (
        <>
            <span className={styles.description}>{appointment.services[0].name}</span>
            {`· `}
        </>
    );
    const price = (
        <PriceItem
            price={orderItem.total ?? '-'}
            originalPrice={
                hasMembershipApplied
                    ? Number(orderItem.originalPrice ?? '0.00').toFixed(2)
                    : Number(orderItem.discount?.amount ?? '0') > 0
                    ? Number(orderItem.amount).toFixed(2)
                    : undefined
            }
            className={styles.price}
        />
    );

    const startHour = appointment.duration.from.clone().format('h:mm a');

    const duration = `${appointment.duration.to.clone().diff(appointment.duration.from.clone(), 'minutes')}min`;

    const staffMember = appointment.services[0].staff?.firstName;
    const secondLine = `${startHour} · ${duration} · ${staffMember}`;

    return (
        <>
            <div className={styles.firstLineContainer}>
                {hasMembershipApplied && <MembershipIcon className={styles.membershipIcon} />}
                <span className={styles.firstLineText}>
                    {firstLine}
                    {price}
                </span>
            </div>
            <span className={styles.secondLine}>{secondLine}</span>
        </>
    );
};

export default AppointmentData;
